import React, { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

import SecondaryControlButton from '../../../../../../../services/prints/components/PrintProductConfigurator/components/PrintProductConfiguratorControlsPane/SecondaryControlButton';
import {
  CARD_ELEMENT_TYPE,
  ORIENTATION,
} from '../../../../../../../services/cards/constants';
import { getCardPhotoSlots, getCardTeamPhotoSlots } from './helpers';
import SecondaryControlButtonSizeRectangle from '../../../../../../../services/prints/components/PrintProductConfigurator/components/PrintProductConfiguratorControlsPane/SecondaryControlButton/SecondaryControlButtonSizeRectangle';

const propTypes = {
  className: PropTypes.string,
  cardPrintSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
  cardOrientation: PropTypes.oneOf(Object.values(ORIENTATION)).isRequired,
  onCardElementCreate: PropTypes.func.isRequired,
  zElementIndexMax: PropTypes.number,
};

const CardDesignerPhotoControls = ({
  className,
  cardPrintSize,
  cardOrientation,
  onCardElementCreate,
  zElementIndexMax,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  const cardPhotoSlots = useMemo(
    () => getCardPhotoSlots({ cardPrintSize, cardOrientation }),
    [cardPrintSize],
  );
  const cardTeamPhotoSlots = useMemo(
    () => getCardTeamPhotoSlots({ cardPrintSize, cardOrientation }),
    [cardPrintSize],
  );

  return (
    <div className={classes}>
      {cardTeamPhotoSlots?.length > 0 && (
        <Fragment>
          <p className="text-sm mb-0">TEAM SLOTS</p>
          <hr className="my-1" />
          <div className="card-designer-layout-controls-list card-designer-layout-photo-controls-list">
            {cardTeamPhotoSlots.map(teamPhotoSlot => {
              return (
                <Fragment>
                  <SecondaryControlButton
                    key={`t-${teamPhotoSlot.label}`}
                    className="is-lg"
                    title={teamPhotoSlot.label}
                    icon={
                      <SecondaryControlButtonSizeRectangle
                        width={teamPhotoSlot.width}
                        height={teamPhotoSlot.height}
                        orientation={teamPhotoSlot.orientation}
                        badgeText={teamPhotoSlot.badgeText}
                        className="rounded"
                      />
                    }
                    onClick={() => {
                      onCardElementCreate({
                        cardElementConfiguration: {
                          is_editable: true,
                          help_placeholder: teamPhotoSlot.badgeText,
                        },
                        cardElementType: CARD_ELEMENT_TYPE.PHOTO,
                        input: {
                          ...teamPhotoSlot.input,
                          z_index: zElementIndexMax ?? 1,
                        },
                      });
                    }}
                    data-for={`t-${teamPhotoSlot.label}-tt`}
                    data-place="top"
                    data-effect="solid"
                    data-tip
                  />
                  {teamPhotoSlot.tooltip && (
                    <ReactTooltip
                      id={`t-${teamPhotoSlot.label}-tt`}
                      place="top"
                      effect="solid"
                      tip
                    >
                      {teamPhotoSlot.tooltip}
                    </ReactTooltip>
                  )}
                </Fragment>
              );
            })}
          </div>
        </Fragment>
      )}
      <p className="text-sm mb-0">PHOTO SLOTS</p>
      <hr className="my-1" />
      <div className="card-designer-layout-controls-list card-designer-layout-photo-controls-list">
        {cardPhotoSlots.map(photoSlot => {
          return (
            <Fragment>
              <SecondaryControlButton
                key={photoSlot.label}
                className="is-lg"
                title={photoSlot.label}
                icon={
                  <SecondaryControlButtonSizeRectangle
                    width={photoSlot.width}
                    height={photoSlot.height}
                    orientation={photoSlot.orientation}
                    badgeText={photoSlot.badgeText}
                    className="rounded"
                  />
                }
                onClick={() => {
                  onCardElementCreate({
                    cardElementConfiguration: {
                      is_editable: true,
                      help_placeholder: photoSlot.badgeText,
                    },
                    cardElementType: CARD_ELEMENT_TYPE.PHOTO,
                    input: {
                      ...photoSlot.input,
                      z_index: zElementIndexMax ?? 1,
                    },
                  });
                }}
                data-for={`${photoSlot.label}-tt`}
                data-place="top"
                data-effect="solid"
                data-tip
              />
              {photoSlot.tooltip && (
                <ReactTooltip
                  id={`${photoSlot.label}-tt`}
                  place="top"
                  effect="solid"
                  tip
                >
                  {photoSlot.tooltip}
                </ReactTooltip>
              )}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};

CardDesignerPhotoControls.propTypes = propTypes;

export default CardDesignerPhotoControls;
